<template>
  <v-container fluid>
    <!-- Botón volver -->
    <v-btn text class="mb-3" :to="{ name: 'asignacion-beneficiarios-listado' }">
      <v-icon left>mdi-arrow-left</v-icon>
      Volver al listado
    </v-btn>

    <v-row>
      <!-- Columna izquierda: Información, Estado, Documentos/Observaciones/Bitácora -->
      <v-col cols="12" md="6">
        <!-- Información del beneficiario -->
        <v-card :loading="cargando">
          <v-card-title class="d-flex align-center">
            <v-icon left class="mr-2">mdi-account</v-icon>
            {{ postulacion.nombre_completo || getNombreCompleto(postulacion) }}
            <v-spacer />
            <v-chip :color="getEstadoColor(postulacion.estado)" dark class="mr-2">
              {{ getEstadoTexto(postulacion.estado) }}
            </v-chip>
          </v-card-title>

          <v-card-text>
            <v-list dense>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>RUT</v-list-item-subtitle>
                  <v-list-item-title>{{ postulacion.rut }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>Sector</v-list-item-subtitle>
                  <v-list-item-title>
                    <v-chip x-small :color="getSectorColor(postulacion.sector)">
                      {{ getSectorTexto(postulacion.sector) }}
                    </v-chip>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-if="postulacion.correo_electronico">
                <v-list-item-content>
                  <v-list-item-subtitle>Correo</v-list-item-subtitle>
                  <v-list-item-title>{{ postulacion.correo_electronico }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-if="postulacion.certificado">
                <v-list-item-content>
                  <v-list-item-subtitle>Municipalidad</v-list-item-subtitle>
                  <v-list-item-title>{{ postulacion.certificado.municipalidad_id }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-if="postulacion.fecha_beneficiario">
                <v-list-item-content>
                  <v-list-item-subtitle>Fecha asignación como beneficiario</v-list-item-subtitle>
                  <v-list-item-title>{{ formatearFecha(postulacion.fecha_beneficiario) }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-if="postulacion.fecha_pago">
                <v-list-item-content>
                  <v-list-item-subtitle>Fecha de pago</v-list-item-subtitle>
                  <v-list-item-title>{{ formatearFecha(postulacion.fecha_pago) }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>

        <!-- Evaluar Cumplimiento de Requisitos (solo para estado 'enviada' u 'observada', SUBDERE) -->
        <!-- <v-card v-if="['enviada', 'observada'].includes(postulacion.estado) && esSubdere" class="mt-4">
          <v-card-title>
            <v-icon left class="mr-2">mdi-clipboard-check</v-icon>
            Evaluar Cumplimiento de Requisitos
          </v-card-title>
          <v-card-text>
            <v-alert type="info" dense text class="mb-4">
              Evalúe si esta postulación cumple los requisitos antes de validarla.
            </v-alert>

            <v-chip v-if="postulacion.cumple_requisitos === true" color="success" dark class="mb-4">
              <v-icon small left>mdi-check</v-icon> Cumple requisitos
            </v-chip>
            <v-chip v-else-if="postulacion.cumple_requisitos === false" color="error" dark class="mb-4">
              <v-icon small left>mdi-close</v-icon> No cumple requisitos
            </v-chip>

            <v-radio-group v-model="cumpleRequisitos" row>
              <v-radio :value="true" color="success">
                <template #label>
                  <span class="success--text">
                    <v-icon small color="success" left>mdi-check-circle</v-icon>
                    Sí, cumple requisitos
                  </span>
                </template>
              </v-radio>
              <v-radio :value="false" color="error">
                <template #label>
                  <span class="error--text">
                    <v-icon small color="error" left>mdi-close-circle</v-icon>
                    No cumple requisitos
                  </span>
                </template>
              </v-radio>
            </v-radio-group>

            <v-alert v-if="cumpleRequisitos === false" type="warning" dense text class="mt-2">
              Esta postulación se marcará como "No cumple requisitos" y no podrá ser validada.
            </v-alert>

            <v-btn
              color="primary"
              :loading="guardandoCumple"
              :disabled="cumpleRequisitos === null"
              @click="guardarCumpleRequisitos"
            >
              <v-icon left>mdi-content-save</v-icon>
              Guardar Evaluación
            </v-btn>
          </v-card-text>
        </v-card> -->

        <!-- Solicitud de retorno pendiente -->
        <v-card v-if="esSolicitudPendiente" class="mt-4" outlined>
          <v-card-title class="amber darken-3 white--text py-2">
            <v-icon left color="white">mdi-clock-alert-outline</v-icon>
            Solicitud de cambio de estado pendiente
          </v-card-title>
          <v-card-text class="pt-3">
            <v-alert type="warning" dense text class="mb-3">
              <template v-if="esSubdere">
                La municipalidad ha solicitado un cambio de estado. Revise el motivo y use el selector de abajo para aprobar o rechazar.
              </template>
              <template v-else>
                Su solicitud de cambio de estado está pendiente de aprobación por SUBDERE.
              </template>
            </v-alert>
            <div class="text-subtitle-2 mb-1">Motivo de la solicitud:</div>
            <p class="text-body-2 grey--text text--darken-2">{{ ultimaEntradaBitacora?.observacion || '-' }}</p>
          </v-card-text>
        </v-card>

        <!-- Cambiar Estado -->
        <v-card v-if="transicionesDisponibles.length > 0" class="mt-4">
          <v-card-title>
            <v-icon left class="mr-2">mdi-swap-horizontal</v-icon>
            Cambiar Estado
          </v-card-title>
          <v-card-text>
            <v-select
              v-model="transicionSeleccionada"
              :items="transicionesDisponiblesSelect"
              label="Nuevo estado"
              outlined
              dense
              @change="cargarDocumentosRequeridos"
            />

            <!-- Documentos requeridos para la transición -->
            <template v-if="transicionSeleccionada && documentosRequeridos.length > 0">
              <v-divider class="my-3" />
              <v-subheader class="px-0">
                Documentos requeridos para esta transición
              </v-subheader>
              <template v-for="(doc, idx) in documentosRequeridos">
                <v-card
                  v-if="doc.tipo !== 'certificado_trabajo_pesado' || (doc.tipo === 'certificado_trabajo_pesado' && doc.obligatorio)"
                  :key="idx"
                  outlined
                  class="pa-3 mb-2"
                >
                  <div class="d-flex align-center mb-2">
                    <v-icon
                      :color="doc.subido ? 'green' : (doc.obligatorio ? 'red' : 'grey')"
                      class="mr-2"
                    >
                      {{ doc.subido ? 'mdi-check-circle' : (doc.obligatorio ? 'mdi-alert-circle' : 'mdi-circle-outline') }}
                    </v-icon>
                    <span>
                      {{ doc.label }}
                      <v-chip v-if="doc.obligatorio" x-small color="red" dark class="ml-1">Obligatorio</v-chip>
                      <v-chip v-else x-small color="grey" dark class="ml-1">Opcional</v-chip>
                    </span>
                  </div>
                  <v-file-input
                    v-if="!doc.subido"
                    v-model="archivosTransicion[doc.tipo]"
                    accept=".pdf"
                    :label="'Seleccionar ' + doc.label"
                    outlined
                    dense
                    hide-details
                    prepend-icon="mdi-file-pdf-box"
                  />
                  <v-chip v-else small color="green" dark>
                    <v-icon small left>mdi-check</v-icon>
                    Documento ya subido
                  </v-chip>
                </v-card>
              </template>
            </template>

            <!-- Campos adicionales para transición a Lista de Espera -->
            <template v-if="transicionSeleccionada === 'lista_espera'">
              <v-divider class="my-3" />
              <v-subheader class="px-0">Proceso</v-subheader>
              <v-select
                v-model="formularioListaEspera.tipo_proceso"
                :items="tiposProceso"
                label="Tipo de proceso"
                outlined
                dense
              />
            </template>

            <!-- Campos adicionales para transición a Beneficiario -->
            <template v-if="transicionSeleccionada === 'beneficiario'">
              <v-divider class="my-3" />
              <v-subheader class="px-0">Resolución Lista de Espera</v-subheader>
              <v-text-field
                v-model="formularioBeneficiario.resolucion_lista_espera_numero"
                label="Número de resolución"
                outlined
                dense
              />
              <v-menu v-model="menuFechaResLE" :close-on-content-click="false" offset-y min-width="auto">
                <template #activator="{ on, attrs }">
                  <v-text-field
                    v-model="formularioBeneficiario.resolucion_lista_espera_fecha"
                    label="Fecha de resolución"
                    readonly
                    outlined
                    dense
                    v-bind="attrs"
                    v-on="on"
                  />
                </template>
                <v-date-picker v-model="formularioBeneficiario.resolucion_lista_espera_fecha" @input="menuFechaResLE = false" />
              </v-menu>

              <v-subheader class="px-0">Resolución Beneficiario</v-subheader>
              <v-text-field
                v-model="formularioBeneficiario.resolucion_beneficiario_numero"
                label="Número de resolución"
                outlined
                dense
              />
              <v-menu v-model="menuFechaResBen" :close-on-content-click="false" offset-y min-width="auto">
                <template #activator="{ on, attrs }">
                  <v-text-field
                    v-model="formularioBeneficiario.resolucion_beneficiario_fecha"
                    label="Fecha de resolución"
                    readonly
                    outlined
                    dense
                    v-bind="attrs"
                    v-on="on"
                  />
                </template>
                <v-date-picker v-model="formularioBeneficiario.resolucion_beneficiario_fecha" @input="menuFechaResBen = false" />
              </v-menu>

              <v-subheader class="px-0">Publicación Diario Oficial</v-subheader>
              <v-menu v-model="menuFechaDO" :close-on-content-click="false" offset-y min-width="auto">
                <template #activator="{ on, attrs }">
                  <v-text-field
                    v-model="formularioBeneficiario.fecha_publicacion_diario_oficial"
                    label="Fecha de publicación"
                    readonly
                    outlined
                    dense
                    v-bind="attrs"
                    v-on="on"
                  />
                </template>
                <v-date-picker v-model="formularioBeneficiario.fecha_publicacion_diario_oficial" @input="menuFechaDO = false" />
              </v-menu>
            </template>

            <!-- Campos adicionales para transición a Pagado -->
            <template v-if="transicionSeleccionada === 'pagado'">
              <v-divider class="my-3" />
              <v-subheader class="px-0">Resolución de Pago</v-subheader>
              <v-text-field
                v-model="formularioPagado.resolucion_pago_numero"
                label="N° resolución de pago"
                outlined
                dense
              />
              <v-menu v-model="menuFechaResPago" :close-on-content-click="false" offset-y min-width="auto">
                <template #activator="{ on, attrs }">
                  <v-text-field
                    v-model="formularioPagado.resolucion_pago_fecha"
                    label="Fecha resolución de pago"
                    readonly
                    outlined
                    dense
                    v-bind="attrs"
                    v-on="on"
                  />
                </template>
                <v-date-picker v-model="formularioPagado.resolucion_pago_fecha" @input="menuFechaResPago = false" />
              </v-menu>
              <v-menu v-model="menuFechaPago" :close-on-content-click="false" offset-y min-width="auto">
                <template #activator="{ on, attrs }">
                  <v-text-field
                    v-model="formularioPagado.fecha_pago"
                    label="Fecha de pago por TGR"
                    readonly
                    outlined
                    dense
                    v-bind="attrs"
                    v-on="on"
                  />
                </template>
                <v-date-picker v-model="formularioPagado.fecha_pago" @input="menuFechaPago = false" />
              </v-menu>
            </template>

            <!-- Campos para solicitudes de retorno de estado (municipalidad) -->
            <template v-if="estadosSolicitud.includes(transicionSeleccionada)">
              <v-divider class="my-3" />
              <v-subheader class="px-0">Motivo de la solicitud</v-subheader>
              <v-alert type="info" dense text class="mb-3">
                Esta solicitud quedará pendiente de aprobación por SUBDERE antes de ejecutarse.
              </v-alert>
              <v-textarea
                v-model="formularioSolicitudRetorno.motivo_solicitud_retorno"
                label="Explique el motivo del cambio de estado"
                outlined
                dense
                rows="4"
                counter="2000"
                :rules="[v => !v || v.length <= 2000 || 'Máximo 2000 caracteres']"
              />
            </template>

            <!-- Campos para resolución SUBDERE (aprobar/rechazar solicitud) -->
            <template v-if="esSolicitudPendiente && esSubdere && transicionSeleccionada">
              <v-divider class="my-3" />
              <v-subheader class="px-0">Observación de resolución (opcional)</v-subheader>
              <v-textarea
                v-model="formularioResolucionRetorno.observacion_resolucion_retorno"
                label="Observación al aprobar o rechazar la solicitud"
                outlined
                dense
                rows="3"
                counter="2000"
              />
            </template>

            <!-- Campos adicionales para transición a Otros -->
            <template v-if="transicionSeleccionada === 'otros'">
              <v-divider class="my-3" />
              <v-subheader class="px-0">Detalle de incumplimiento de requisitos</v-subheader>
              <v-textarea
                v-model="formularioOtros.detalle_otros"
                label="Descripción de por qué el funcionario no cumple los requisitos para bonificaciones fiscales"
                outlined
                dense
                rows="4"
                counter="2000"
                :rules="[v => !v || v.length <= 2000 || 'Máximo 2000 caracteres']"
              />
            </template>

            <!-- Botón confirmar transición -->
            <v-btn
              v-if="transicionSeleccionada"
              color="primary"
              class="mt-3"
              block
              :loading="procesandoTransicion"
              :disabled="!puedeConfirmarTransicion"
              @click="confirmarTransicion"
            >
              <v-icon left>mdi-check</v-icon>
              Confirmar {{ getEstadoTexto(transicionSeleccionada) }}
            </v-btn>
          </v-card-text>
        </v-card>

        <!-- Tabs: Documentos, Observaciones, Bitácora -->
        <v-card class="mt-4">
          <v-tabs v-model="tabActiva" background-color="primary" dark>
            <v-tab>
              <v-icon left>mdi-file-document-multiple</v-icon>
              Documentos
            </v-tab>
            <v-tab>
              <v-icon left>mdi-comment-text-multiple</v-icon>
              Observaciones
              <v-badge
                v-if="observacionesSinResponder > 0"
                :content="observacionesSinResponder"
                color="red"
                class="ml-2"
              />
            </v-tab>
            <v-tab>
              <v-icon left>mdi-history</v-icon>
              Bitácora
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="tabActiva">
            <!-- Tab Documentos -->
            <v-tab-item>
              <v-card-text>
                <!-- Documentos de Etapa 1 (Postulación) -->
                <div v-if="documentosEtapa1.length > 0">
                  <v-subheader class="px-0">Documentos de Postulación (Etapa 1)</v-subheader>
                  <v-list dense>
                    <v-list-item
                      v-for="doc in documentosEtapa1"
                      :key="doc.tipo"
                    >
                      <v-list-item-icon>
                        <v-icon color="red">mdi-file-pdf-box</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>{{ doc.nombre }}</v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-btn
                          icon
                          small
                          color="primary"
                          @click="descargarArchivoPostulacion(doc.tipo)"
                        >
                          <v-icon small>mdi-download</v-icon>
                        </v-btn>
                      </v-list-item-action>
                    </v-list-item>
                  </v-list>
                  <v-divider class="mb-2" />
                </div>

                <!-- Documentos de Etapa 2 (Asignación) -->
                <div v-if="documentos.length === 0 && documentosEtapa1.length === 0" class="text-center py-5 grey--text">
                  <v-icon size="48" color="grey lighten-2">mdi-file-document-outline</v-icon>
                  <p class="mt-2">No hay documentos subidos</p>
                </div>
                <template v-if="documentos.length > 0">
                  <v-subheader v-if="documentosEtapa1.length > 0" class="px-0">Documentos de Asignación (Etapa 2)</v-subheader>
                  <v-list dense>
                    <template v-for="(grupo, transicion) in documentosAgrupados">
                      <v-subheader :key="'header-' + transicion" class="px-0">
                        {{ formatearTransicion(transicion) }}
                      </v-subheader>
                      <v-list-item
                        v-for="(doc, idx) in grupo"
                        :key="'doc-' + transicion + '-' + idx"
                      >
                        <v-list-item-icon>
                          <v-icon color="red">mdi-file-pdf-box</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>{{ doc.nombre_original || doc.tipo }}</v-list-item-title>
                          <v-list-item-subtitle>
                            {{ doc.tipo }} - {{ formatearFecha(doc.fecha) }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-btn
                            icon
                            small
                            color="primary"
                            @click="descargarArchivoPostulacion(doc.tipo)"
                          >
                            <v-icon small>mdi-download</v-icon>
                          </v-btn>
                        </v-list-item-action>
                        <v-list-item-action v-if="esSubdere">
                          <v-btn
                            icon
                            small
                            color="error"
                            @click="eliminarDocumento(doc._index)"
                          >
                            <v-icon small>mdi-delete</v-icon>
                          </v-btn>
                        </v-list-item-action>
                      </v-list-item>
                      <v-divider :key="'div-' + transicion" />
                    </template>
                  </v-list>
                </template>
              </v-card-text>
            </v-tab-item>

            <!-- Tab Observaciones -->
            <v-tab-item>
              <v-card-text>
                <!-- Agregar observación (solo SUBDERE) -->
                <div v-if="esSubdere" class="mb-4">
                  <v-textarea
                    v-model="nuevaObservacion"
                    label="Agregar observación"
                    outlined
                    dense
                    rows="3"
                    counter="2000"
                    :rules="[v => !v || v.length <= 2000 || 'Máximo 2000 caracteres']"
                  />
                  <v-btn
                    color="primary"
                    small
                    :loading="enviandoObservacion"
                    :disabled="!nuevaObservacion || nuevaObservacion.length > 2000"
                    @click="agregarObservacion"
                  >
                    <v-icon left small>mdi-send</v-icon>
                    Enviar observación
                  </v-btn>
                </div>

                <div v-if="observaciones.length === 0" class="text-center py-5 grey--text">
                  <v-icon size="48" color="grey lighten-2">mdi-comment-outline</v-icon>
                  <p class="mt-2">No hay observaciones</p>
                </div>

                <!-- Lista de observaciones -->
                <v-timeline v-else dense>
                  <v-timeline-item
                    v-for="obs in observaciones"
                    :key="obs.id"
                    :color="obs.respuesta ? 'green' : 'orange'"
                    small
                  >
                    <v-card outlined class="pa-3">
                      <div class="d-flex align-center mb-1">
                        <strong>{{ obs.usuario_nombre }}</strong>
                        <v-chip x-small class="ml-2" :color="obs.rol === 'subdere' ? 'blue' : 'green'" dark>
                          {{ obs.rol === 'subdere' ? 'SUBDERE' : 'Municipalidad' }}
                        </v-chip>
                        <v-spacer />
                        <span class="text-caption grey--text">{{ formatearFecha(obs.fecha) }}</span>
                      </div>
                      <p class="mb-0">{{ obs.texto }}</p>

                      <!-- Respuesta -->
                      <div v-if="obs.respuesta" class="mt-3 pl-3" style="border-left: 3px solid #4CAF50;">
                        <div class="text-caption grey--text">Respuesta - {{ formatearFecha(obs.respuesta_fecha) }}</div>
                        <p class="mb-0">{{ obs.respuesta }}</p>
                      </div>

                      <!-- Campo para responder (municipalidad) -->
                      <div v-else-if="!esSubdere" class="mt-3">
                        <v-textarea
                          v-model="respuestas[obs.id]"
                          label="Responder observación"
                          outlined
                          dense
                          rows="2"
                          hide-details
                        />
                        <v-btn
                          small
                          color="primary"
                          class="mt-2"
                          :loading="respondiendo === obs.id"
                          :disabled="!respuestas[obs.id]"
                          @click="responderObservacion(obs.id)"
                        >
                          Responder
                        </v-btn>
                      </div>
                    </v-card>
                  </v-timeline-item>
                </v-timeline>
              </v-card-text>
            </v-tab-item>

            <!-- Tab Bitácora -->
            <v-tab-item>
              <v-card-text>
                <div v-if="bitacora.length === 0" class="text-center py-5 grey--text">
                  <v-icon size="48" color="grey lighten-2">mdi-history</v-icon>
                  <p class="mt-2">No hay registros en la bitácora</p>
                </div>
                <v-timeline v-else dense>
                  <v-timeline-item
                    v-for="(entry, idx) in bitacora"
                    :key="idx"
                    :color="getEstadoColor(entry.estado_nuevo)"
                    small
                  >
                    <v-card outlined class="pa-3">
                      <div class="d-flex align-center mb-1">
                        <v-chip x-small :color="getEstadoColor(entry.estado_anterior)" dark>
                          {{ getEstadoTexto(entry.estado_anterior) }}
                        </v-chip>
                        <v-icon small class="mx-2">mdi-arrow-right</v-icon>
                        <v-chip x-small :color="getEstadoColor(entry.estado_nuevo)" dark>
                          {{ getEstadoTexto(entry.estado_nuevo) }}
                        </v-chip>
                        <v-spacer />
                        <span class="text-caption grey--text">{{ formatearFecha(entry.fecha) }}</span>
                      </div>
                      <div class="text-caption">
                        Por: {{ entry.usuario_nombre }}
                      </div>
                      <div v-if="entry.observacion" class="mt-2 text-body-2 grey--text text--darken-2" style="border-left: 3px solid #FB8C00; padding-left: 8px;">
                        {{ entry.observacion }}
                      </div>
                    </v-card>
                  </v-timeline-item>
                </v-timeline>
              </v-card-text>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-col>

      <!-- Columna derecha: Formulario de Asignación -->
      <v-col cols="12" md="6">
        <!-- Resolución de Pago (solo lectura cuando ya está pagado) -->
        <v-card v-if="postulacion.estado === 'pagado'" class="mb-4">
          <v-card-title>
            <v-icon left class="mr-2">mdi-cash-check</v-icon>
            Resolución de Pago
          </v-card-title>
          <v-card-text>
            <v-text-field
              :value="formulario.resolucion_pago_numero"
              label="N° resolución de pago"
              outlined
              dense
              readonly
              filled
            />
            <v-text-field
              :value="formulario.resolucion_pago_fecha"
              label="Fecha resolución de pago"
              outlined
              dense
              readonly
              filled
            />
            <v-text-field
              :value="formulario.fecha_pago"
              label="Fecha de pago por TGR"
              outlined
              dense
              readonly
              filled
            />
          </v-card-text>
        </v-card>

        <v-card v-if="postulacion.formulario_asignacion && !['enviada', 'observada', 'validada', 'lista_espera', 'beneficiario', 'pagado'].includes(postulacion.estado) || ['dejacion', 'desiste'].includes(transicionSeleccionada)">
          <v-card-title class="d-flex align-center flex-wrap justify-end" style="gap: 8px;">
            <v-icon left class="mr-2">mdi-form-select</v-icon>
            Formulario de Asignación
            <v-spacer />
            <v-menu v-if="esSubdere" offset-y left>
              <template #activator="{ on, attrs }">
                <v-btn small outlined color="primary" v-bind="attrs" v-on="on">
                  <v-icon small left>mdi-bank</v-icon>
                  FCM
                  <v-icon small right>mdi-chevron-down</v-icon>
                </v-btn>
              </template>
              <v-list dense>
                <template v-if="['beneficiario', 'dejacion'].includes(postulacion.estado)">
                  <v-subheader>Este postulante</v-subheader>
                  <v-list-item @click="habilitarSolicitarFcm()"
                    v-if="postulacion?.datos?.habilitado_solicitar_fcm === false"
                  >
                    <v-list-item-icon><v-icon small color="success">mdi-check-circle-outline</v-icon></v-list-item-icon>
                    <v-list-item-title>Habilitar</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="deshabilitarSolicitarFcm()"
                    v-if="(postulacion?.datos?.habilitado_solicitar_fcm === true || postulacion?.datos?.habilitado_solicitar_fcm === null || postulacion?.datos?.habilitado_solicitar_fcm === undefined)"
                  >
                    <v-list-item-icon><v-icon small color="error">mdi-close-circle-outline</v-icon></v-list-item-icon>
                    <v-list-item-title>Deshabilitar</v-list-item-title>
                  </v-list-item>
                  <v-divider />
                </template>
                <v-subheader>Toda la municipalidad</v-subheader>
                <v-list-item @click="habilitarSolicitarFcmMunicipalidad()">
                  <v-list-item-icon><v-icon small color="success">mdi-check-circle</v-icon></v-list-item-icon>
                  <v-list-item-title>Habilitar</v-list-item-title>
                </v-list-item>
                <v-list-item @click="deshabilitarSolicitarFcmMunicipalidad()">
                  <v-list-item-icon><v-icon small color="error">mdi-close-circle</v-icon></v-list-item-icon>
                  <v-list-item-title>Deshabilitar</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <v-btn
              v-if="esSubdere && postulacion?.datos?.habilitado_editar_formulario === false && ['beneficiario', 'dejacion', 'cese_funciones', 'fallecimiento'].includes(postulacion.estado)"
              small
              outlined
              color="warning"
              @click="habilitarGuardarFormulario()"
            >
              <v-icon small left>mdi-pencil</v-icon>
              Habilitar guardar formulario
            </v-btn>
            <v-btn
              v-if="esSubdere && !edicionHabilitadaSubdere && ['beneficiario', 'dejacion', 'cese_funciones', 'fallecimiento'].includes(postulacion.estado)"
              small
              outlined
              color="warning"
              @click="edicionHabilitadaSubdere = true"
            >
              <v-icon small left>mdi-pencil</v-icon>
              Habilitar edición
            </v-btn>
            <v-chip v-if="!formularioEditable" small color="grey" dark>Solo lectura</v-chip>
          </v-card-title>
          <v-card-text>
            <!-- ═══ CAMPOS COMUNES (todos los estados) ═══ -->
            <template v-if="mostrarCampoParaDejacion">
              <v-subheader class="px-0 font-weight-bold">Oficio Alcaldicio</v-subheader>
              <v-text-field
                v-model="formulario.numero_oficio_alcaldicio"
                label="N° oficio alcaldicio"
                outlined
                dense
                :readonly="!formularioEditable"
              />
              <v-text-field
                v-model="formulario.fecha_oficio_alcaldicio"
                label="Fecha oficio alcaldicio"
                outlined
                dense
                type="date"
                :readonly="!formularioEditable"
              />

            </template>

            <!-- ═══ CAMPOS DE DEJACIÓN (dejación y posteriores, no desiste) ═══ -->
            <template v-if="mostrarSeccionDejacion">
              <v-subheader class="px-0 font-weight-bold">Datos de Dejación</v-subheader>
              <v-text-field
                v-model="formulario.fecha_cese_funciones"
                label="Fecha cese de funciones"
                outlined
                dense
                type="date"
                :readonly="!formularioEditable"
              />
              <v-radio-group
                v-if="postulacion.sector !== 'cementerio'"
                v-model="formulario.solicita_anticipo_fcm"
                label="¿Solicita Anticipo F.C.M?"
                row
                :readonly="!formularioEditable"
                :disabled="postulacion?.datos?.habilitado_solicitar_fcm === false"
              >
                <v-radio :value="false" label="No" />
                <v-radio :value="true" label="Sí" />
              </v-radio-group>

              <template v-if="postulacion.sector !== 'cementerio' && formulario.solicita_anticipo_fcm">
                <v-subheader class="px-0 font-weight-bold">Bonificaciones ($)</v-subheader>
                <v-text-field
                  v-model="bonificacionRetiroPesosFormateada"
                  label="Bonificación retiro voluntario ($)"
                  outlined
                  dense
                  type="text"
                  prefix="$"
                  autocomplete="off"
                  inputmode="numeric"
                  @input="calcularBonoCargoMunicipal"
                  :readonly="!formularioEditable"
                />
                <v-text-field
                  v-model="bonificacionComplementariaPesosFormateada"
                  label="Bonificación complementaria ($)"
                  outlined
                  dense
                  type="text"
                  prefix="$"
                  autocomplete="off"
                  inputmode="numeric"
                  @input="calcularBonoCargoMunicipal"
                  :readonly="!formularioEditable"
                />
                <v-text-field
                  v-model="bonificacionMunicipalPesosFormateada"
                  label="Total Bonificación de Cargo Municipal ($)"
                  disabled
                  outlined
                  dense
                  type="text"
                  prefix="$"
                  autocomplete="off"
                  inputmode="numeric"
                  :readonly="!formularioEditable"
                />
              </template>

              <!-- Campos de Convenio Anticipo FCM -->
               <!-- Se comentaron los campos de abajo, porque segun Nicolas, no van -->
              <!-- <v-subheader class="px-0 font-weight-bold">Convenio</v-subheader> -->
              <!-- <v-text-field
                v-model="formulario.numero_expediente"
                label="Número expediente"
                outlined
                dense
                :readonly="!formularioEditable"
              />
              <v-text-field
                v-model="formulario.numero_convenio"
                label="Número convenio"
                outlined
                dense
                :readonly="!formularioEditable"
              />
              <v-text-field
                v-model="formulario.numero_decreto_ministerial"
                label="Número decreto ministerial"
                outlined
                dense
                :readonly="!formularioEditable"
              />
              <v-text-field
                v-model="formulario.fecha_decreto_ministerial"
                label="Fecha decreto ministerial"
                outlined
                dense
                type="date"
                :readonly="!formularioEditable"
              />
              <v-text-field
                v-model="formulario.fecha_transferencia_tesoreria_fcm"
                label="Fecha de Transf. Tesorería FCM"
                outlined
                dense
                type="date"
                :readonly="!formularioEditable"
              /> -->
            </template>

            <!-- ═══ DOCUMENTOS ANTICIPO FCM (solo dejación con solicita_anticipo_fcm) ═══ -->
            <template v-if="mostrarSeccionDejacion && formulario.solicita_anticipo_fcm">
              <v-subheader class="px-0 font-weight-bold">Documentos Solicitud Anticipo FCM</v-subheader>
              <v-card
                v-for="(doc, idx) in documentosAnticipoFcm"
                :key="'afcm-' + idx"
                outlined
                class="pa-3 mb-2"
              >
                <div class="d-flex align-center mb-2">
                  <v-icon
                    :color="doc.subido ? 'green' : 'red'"
                    class="mr-2"
                  >
                    {{ doc.subido ? 'mdi-check-circle' : 'mdi-alert-circle' }}
                  </v-icon>
                  <span class="text-body-2">
                    {{ doc.label }}
                    <v-chip v-if="doc.obligatorio" x-small color="red" dark class="ml-1">Obligatorio</v-chip>
                    <v-chip v-else x-small color="grey" dark class="ml-1">Opcional</v-chip>
                  </span>
                </div>
                <v-file-input
                  v-if="!doc.subido && formularioEditable"
                  v-model="archivosAnticipoFcm[doc.tipo]"
                  accept=".pdf"
                  :label="'Seleccionar ' + doc.label"
                  outlined
                  dense
                  hide-details
                  prepend-icon="mdi-file-pdf-box"
                  @change="subirDocumentoAnticipoFcm(doc.tipo)"
                />
                <v-chip v-if="doc.subido" small color="green" dark>
                  <v-icon small left>mdi-check</v-icon>
                  Documento subido
                </v-chip>
              </v-card>
            </template>

            <!-- ═══ CAMPOS DE CESE DE FUNCIONES (cese y posteriores) ═══ -->
            <template v-if="mostrarSeccionCese">
              <v-subheader class="px-0 font-weight-bold">Datos del Cese de Funciones</v-subheader>
              <v-select
                v-model="formulario.causa_cese"
                :items="opcionesCausaCese"
                label="Causa de cese"
                outlined
                dense
                :readonly="!formularioEditable"
              />
              <v-file-input
                v-if="formularioEditable && formulario.causa_cese === 'fallecimiento'"
                v-model="archivoPosesionEfectiva"
                accept=".pdf"
                label="Certificado Posesión Efectiva"
                outlined
                dense
                prepend-icon="mdi-file-pdf-box"
                hint="Seleccione el certificado y se subirá al guardar"
                persistent-hint
              />
              <v-chip v-if="formulario.archivo_posesion_efectiva_url" small color="green" dark class="mb-4">
                <v-icon small left>mdi-check</v-icon>
                Certificado Posesión Efectiva subido
              </v-chip>
              <v-text-field
                v-if="!mostrarSeccionDejacion"
                v-model="formulario.fecha_cese_funciones"
                label="Fecha cese de funciones"
                outlined
                dense
                type="date"
                :readonly="!formularioEditable"
                class="mt-3"
              />
              <v-text-field
                v-model="jornadaTrabajoFormateada"
                label="Horas de jornada de trabajo"
                outlined
                dense
                type="number"
                :readonly="!formularioEditable"
              />

              <v-subheader class="px-0 font-weight-bold">Antigüedad</v-subheader>
              <v-text-field
                v-model.number="formulario.anios_antiguedad_postular"
                label="Años antigüedad postular"
                outlined
                dense
                type="number"
                disabled
                :readonly="!formularioEditable"
              />

              <v-subheader class="px-0 font-weight-bold">Antigüedad al cese de funciones</v-subheader>
              <v-row>
                <v-col v-if="formulario.antiguedad_cese" cols="12" sm="4">
                  <v-text-field
                    v-model.number="formulario.antiguedad_cese.anios"
                    label="Años"
                    outlined
                    dense
                    type="number"
                    :readonly="!formularioEditable"
                  />
                </v-col>
                <v-col v-if="formulario.antiguedad_cese" cols="12" sm="4">
                  <v-text-field
                    v-model.number="formulario.antiguedad_cese.meses"
                    label="Meses"
                    outlined
                    dense
                    type="number"
                    :readonly="!formularioEditable"
                  />
                </v-col>
                <v-col v-if="formulario.antiguedad_cese" cols="12" sm="4">
                  <v-text-field
                    v-model.number="formulario.antiguedad_cese.dias"
                    label="Días"
                    outlined
                    dense
                    type="number"
                    :readonly="!formularioEditable"
                  />
                </v-col>
              </v-row>

              <v-subheader class="px-0 font-weight-bold">Antigüedad en otros municipios</v-subheader>
              <div class="d-flex align-end mb-5">
                <v-checkbox
                  v-model="formulario.posee_antiguedad_otros_municipios"
                  label="Posee antigüedad en otros municipios"
                  hide-details
                  :readonly="!formularioEditable"
                />
              </div>
              <v-row v-if="formulario.posee_antiguedad_otros_municipios">
                <v-col v-if="formulario.antiguedad_otros_municipios" cols="12" sm="4">
                  <v-text-field
                    v-model.number="formulario.antiguedad_otros_municipios.anios"
                    label="Años"
                    outlined
                    dense
                    type="number"
                    :readonly="!formularioEditable"
                  />
                </v-col>
                <v-col v-if="formulario.antiguedad_otros_municipios" cols="12" sm="4">
                  <v-text-field
                    v-model.number="formulario.antiguedad_otros_municipios.meses"
                    label="Meses"
                    outlined
                    dense
                    type="number"
                    :readonly="!formularioEditable"
                  />
                </v-col>
                <v-col v-if="formulario.antiguedad_otros_municipios" cols="12" sm="4">
                  <v-text-field
                    v-model.number="formulario.antiguedad_otros_municipios.dias"
                    label="Días"
                    outlined
                    dense
                    type="number"
                    :readonly="!formularioEditable"
                  />
                </v-col>
              </v-row>
              <v-text-field
                :value="totalAntiguedadCalculado"
                label="Total antigüedad"
                outlined
                dense
                readonly
                filled
              />

              <template v-if="postulacion.sector !== 'cementerio'">
                <v-subheader class="px-0 font-weight-bold">Bonificaciones ($)</v-subheader>
                <v-text-field
                  v-model="bonificacionRetiroPesosCeseFuncionesFormateada"
                  label="Bonificación retiro voluntario ($)"
                  outlined
                  dense
                  type="text"
                  prefix="$"
                  autocomplete="off"
                  inputmode="numeric"
                  @input="calcularBonoCeseFunciones"
                  :readonly="!formularioEditable"
                />
                <v-text-field
                  v-model="bonificacionComplementariaPesosCeseFuncionesFormateada"
                  label="Bonificación complementaria ($)"
                  outlined
                  dense
                  type="text"
                  prefix="$"
                  autocomplete="off"
                  inputmode="numeric"
                  @input="calcularBonoCeseFunciones"
                  :readonly="!formularioEditable"
                />
                <v-text-field
                  v-model="bonificacionMunicipalPesosCeseFuncionesFormateada"
                  label="Total Bonificación de Cargo Municipal ($)"
                  disabled
                  outlined
                  dense
                  type="text"
                  prefix="$"
                  autocomplete="off"
                  inputmode="numeric"
                  :readonly="!formularioEditable"
                />
              </template>

              <v-subheader class="px-0 font-weight-bold">Bonificaciones (UF)</v-subheader>
              <v-text-field
                v-model.number="formulario.bonificacion_adicional_uf"
                label="Bonificación adicional (UF)"
                outlined
                dense
                type="number"
                suffix="UF"
                disabled
                :readonly="!formularioEditable"
              />
              <template v-if="postulacion.sector !== 'cementerio'">
                <v-text-field
                  v-model.number="formulario.bono_antiguedad_uf"
                  label="Bono antigüedad (UF)"
                  outlined
                  dense
                  type="number"
                  suffix="UF"
                  disabled
                  :readonly="!formularioEditable"
                />
                <v-subheader class="px-0 font-weight-bold">Trabajo Pesado</v-subheader>
                <div class="d-flex align-end mb-5">
                  <v-checkbox
                    v-model="formulario.solicita_bono_trabajo_pesado"
                    label="Solicita bono trabajo pesado"
                    hide-details
                    :readonly="!formularioEditable"
                  />
                </div>
                <template v-if="formulario.solicita_bono_trabajo_pesado">
                  <v-text-field
                    v-model.number="formulario.anios_trabajo_pesado"
                    label="Años trabajo pesado"
                    outlined
                    dense
                    type="number"
                    :readonly="!formularioEditable"
                  />
                  <v-text-field
                    v-model.number="formulario.bono_trabajo_pesado_uf"
                    label="Bono trabajo pesado (UF)"
                    outlined
                    dense
                    type="number"
                    suffix="UF"
                    disabled
                    :readonly="!formularioEditable"
                  />
                  <!-- <v-file-input
                    v-if="formularioEditable"
                    v-model="archivoTrabajoPesadoAfp"
                    accept=".pdf"
                    label="Certificado Trabajo Pesado AFP"
                    outlined
                    dense
                    prepend-icon="mdi-file-pdf-box"
                    hint="Seleccione el certificado y se subirá al guardar"
                    persistent-hint
                  /> -->
                  <v-chip v-if="formulario.archivo_trabajo_pesado_afp_url" small color="green" dark class="mb-4">
                    <v-icon small left>mdi-check</v-icon>
                    Certificado Trabajo Pesado AFP subido
                  </v-chip>
                </template>

                <v-subheader class="px-0 font-weight-bold">Total Bonificación de Cargo Fiscal</v-subheader>
                <v-text-field
                  v-model.number="totalBonificacionCargoFiscalUf"
                  label="Total Bonificación de Cargo Fiscal (UF)"
                  outlined
                  dense
                  type="number"
                  suffix="UF"
                  disabled
                  readonly
                />
              </template>

              <v-subheader class="px-0 font-weight-bold">Decreto de Cese</v-subheader>
              <v-text-field
                v-model="formulario.numero_decreto_cese"
                label="N° decreto cese de funciones"
                outlined
                dense
                :readonly="!formularioEditable"
              />
              <v-text-field
                v-model="formulario.fecha_decreto_cese"
                label="Fecha decreto cese de funciones"
                outlined
                dense
                type="date"
                :readonly="!formularioEditable"
              />
            </template>

            <!-- ═══ CAMPOS SOLO DESISTIMIENTO ═══ -->
            <template v-if="mostrarSeccionDesiste">
              <v-text-field
                v-model="formulario.numero_expediente"
                label="Número expediente"
                outlined
                dense
                :readonly="!formularioEditable"
              />
            </template>

            <!-- ═══ CAMPOS DE OTROS ═══ -->
            <template v-if="mostrarSeccionOtros">
              <v-subheader class="px-0 font-weight-bold">Detalle de incumplimiento de requisitos</v-subheader>
              <v-textarea
                v-model="formulario.detalle_otros"
                label="Descripción de por qué el funcionario no cumple los requisitos para bonificaciones fiscales"
                outlined
                dense
                rows="4"
                readonly
                filled
              />
            </template>

            <!-- ═══ OBSERVACIÓN (todos los estados) ═══ -->
            <v-subheader class="px-0 font-weight-bold">Observación</v-subheader>
            <v-textarea
              v-model="formulario.observacion"
              label="Observación del formulario"
              outlined
              dense
              rows="3"
              :readonly="!formularioEditable"
            />

            <!-- Botón guardar -->
            <!-- Nota: Beneficiario puede pasar a dejacion o desiste y al apretar confirmar cambio se ejecuta automaticamente guardar formulario para esos estados -->
            <v-btn
              v-if="formularioEditable && !['beneficiario'].includes(postulacion.estado)"
              color="primary"
              :loading="guardandoFormulario"
              :disabled="guardandoFormulario || !puedeGuardarFormulario || (postulacion?.datos?.habilitado_editar_formulario === false && !esSubdere)"
              @click="guardarFormularioAsignacion"
            >
              <v-icon left>mdi-content-save</v-icon>
              Guardar Formulario {{ postulacion?.datos?.habilitado_editar_formulario === false ? '(No habilitado para Municipalidad)' : '' }}
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Diálogo confirmar transición -->
    <v-dialog v-model="dialogConfirmar" max-width="500">
      <v-card>
        <v-card-title class="text-h5">
          Confirmar cambio de estado
        </v-card-title>
        <v-card-text>
          ¿Está seguro que desea cambiar el estado de
          <strong>{{ getEstadoTexto(postulacion.estado) }}</strong>
          a
          <strong>{{ getEstadoTexto(transicionSeleccionada) }}</strong>?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogConfirmar = false">
            Cancelar
          </v-btn>
          <v-btn color="primary" text :loading="procesandoTransicion" @click="ejecutarTransicion">
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { apiClient } from '@/admin/services/API'
import { format } from 'date-fns'
import { notificar, notificarErrorResponse } from '@/admin/utils/notificar'

export default {
  name: 'AsignacionBeneficiarioDetalle',
  data() {
    return {
      tablaBonoAdicional: [
        {anio_min: 10, anio_max: 19, monto_uf: 400},
        {anio_min: 20, anio_max: 24, monto_uf: 440},
        {anio_min: 25, anio_max: 29, monto_uf: 480},
        {anio_min: 30, anio_max: 34, monto_uf: 520},
        {anio_min: 35, anio_max: 1000, monto_uf: 560},
      ],
      tablaBonoAntiguedad: [
        {anio: 35, monto_uf: 5},
        {anio: 36, monto_uf: 10},
        {anio: 37, monto_uf: 15},
        {anio: 38, monto_uf: 20},
        {anio: 39, monto_uf: 30},
        {anio: 40, monto_uf: 40},
        {anio: 41, monto_uf: 50},
        {anio: 42, monto_uf: 60},
        {anio: 43, monto_uf: 70},
        {anio: 44, monto_uf: 80},
        {anio: 45, monto_uf: 90},
        {anio: 46, monto_uf: 100},
      ],
      tablaBonoPesado: [
        {anio: 1, monto_uf: 10},
        {anio: 2, monto_uf: 20},
        {anio: 3, monto_uf: 30},
        {anio: 4, monto_uf: 40},
        {anio: 5, monto_uf: 50},
        {anio: 6, monto_uf: 60},
        {anio: 7, monto_uf: 70},
        {anio: 8, monto_uf: 80},
        {anio: 9, monto_uf: 90},
        {anio: 10, monto_uf: 100},
      ],
      postulacion: {},
      transicionesDisponibles: [],
      transicionSeleccionada: null,
      documentosRequeridos: [],
      archivosTransicion: {},
      documentos: [],
      observaciones: [],
      bitacora: [],
      cargando: false,
      procesandoTransicion: false,
      enviandoObservacion: false,
      respondiendo: null,
      tabActiva: 0,
      dialogConfirmar: false,
      nuevaObservacion: '',
      respuestas: {},
      cumpleRequisitos: null,
      guardandoCumple: false,
      formulario: {},
      guardandoFormulario: false,
      documentosAnticipoFcm: [
        { tipo: 'oficio_alcaldicio_anticipo_fcm', label: 'Oficio de Solicitud de Convenio', 'obligatorio': true },
        { tipo: 'cert_secretario_acuerdo_concejo', label: 'Certificado de Aprobación de Concejo', 'obligatorio': true },
        { tipo: 'calculo_remuneraciones_bonificaciones', label: 'Certificado de Cálculo de Remuneraciones', 'obligatorio': true },
        { tipo: 'cert_secretario_no_pago_art1', label: 'Certificado de No Pago - Bonificaciones de Cargo Municipal', 'obligatorio': true },
      ],
      archivosAnticipoFcm: {},
      // archivoTrabajoPesadoAfp: null,
      archivoPosesionEfectiva: null,
      edicionHabilitadaSubdere: false,
      formularioPagado: {
        resolucion_pago_numero: '',
        resolucion_pago_fecha: null,
        fecha_pago: null,
      },
      formularioOtros: {
        detalle_otros: '',
      },
      formularioListaEspera: {
        tipo_proceso: null,
      },
      formularioBeneficiario: {
        resolucion_lista_espera_numero: '',
        resolucion_lista_espera_fecha: null,
        resolucion_beneficiario_numero: '',
        resolucion_beneficiario_fecha: null,
        fecha_publicacion_diario_oficial: null,
      },
      formularioSolicitudRetorno: {
        motivo_solicitud_retorno: '',
      },
      formularioResolucionRetorno: {
        observacion_resolucion_retorno: '',
      },
      menuFechaResLE: false,
      menuFechaResBen: false,
      menuFechaDO: false,
      menuFechaResPago: false,
      menuFechaPago: false,
    }
  },
  watch: {
    'formulario.posee_antiguedad_otros_municipios'(newVal, oldVal) {
      if (oldVal && newVal !== oldVal) {
        this.formulario.antiguedad_otros_municipios = { anios: 0, meses: 0, dias: 0 }
      }
      this.documentosRequeridos.forEach((doc) => {
        if (doc.tipo === 'certificado_antiguedad_otros') {
          doc.obligatorio = !!newVal
        }
      })
    },
    'formulario.jornada_trabajo'(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.montoUfBonoAdicional()
      }
    },
    'totalAntiguedadCalculado'(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.montoUfBonoAdicional()
        this.montoUfBonoAntiguedad()
      }
    },
    'formulario.solicita_bono_trabajo_pesado'(newVal, oldVal) {
      if (newVal !== oldVal && typeof oldVal === 'boolean') {
        this.formulario.anios_trabajo_pesado = 0
        // this.archivoTrabajoPesadoAfp = null
      }
      this.documentosRequeridos.forEach((doc) => {
        if (doc.tipo === 'certificado_trabajo_pesado') {
          doc.obligatorio = !!newVal
        }
      })
    },
    'formulario.anios_trabajo_pesado'(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.montoUfBonoTrabajo()
      }
    },
  },
  computed: {
    totalBonificacionCargoFiscalUf() {
      return (this.formulario.bono_trabajo_pesado_uf || 0) + (this.formulario.bono_antiguedad_uf || 0) + (this.formulario.bonificacion_adicional_uf || 0)
    },
    jornadaTrabajoFormateada: {
      get() {
        if (this.formulario.jornada_trabajo == null || this.formulario.jornada_trabajo === '') return ''
        // Eliminar .00 si existe
        const valor = this.formulario.jornada_trabajo.toString().replace(/\.00$/, '')
        return valor.replace('.', ',')
      },
      set(val) {
        const num = parseFloat(val.replace(',', '.').replace(/[^0-9.,]/g, ''))
        this.formulario.jornada_trabajo = isNaN(num) ? null : num
      }
    },
    bonificacionRetiroPesosFormateada: {
      get() {
        if (this.formulario.bonificacion_retiro_pesos == null || this.formulario.bonificacion_retiro_pesos === '') return ''
        return this.formulario.bonificacion_retiro_pesos
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      },
      set(val) {
        // Elimina puntos y otros caracteres no numéricos
        const num = parseInt(val.replace(/\./g, '').replace(/[^0-9]/g, ''), 10)
        this.formulario.bonificacion_retiro_pesos = isNaN(num) ? null : num
      }
    },
    bonificacionComplementariaPesosFormateada: {
      get() {
        if (this.formulario.bonificacion_complementaria_pesos == null || this.formulario.bonificacion_complementaria_pesos === '') return ''
        return this.formulario.bonificacion_complementaria_pesos
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      },
      set(val) {
        // Elimina puntos y otros caracteres no numéricos
        const num = parseInt(val.replace(/\./g, '').replace(/[^0-9]/g, ''), 10)
        this.formulario.bonificacion_complementaria_pesos = isNaN(num) ? null : num
      }
    },
    bonificacionMunicipalPesosFormateada: {
      get() {
        if (this.formulario.bonificacion_cargo_municipal_pesos == null || this.formulario.bonificacion_cargo_municipal_pesos === '') return ''
        return this.formulario.bonificacion_cargo_municipal_pesos
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      },
      set(val) {
        // Elimina puntos y otros caracteres no numéricos
        const num = parseInt(val.replace(/\./g, '').replace(/[^0-9]/g, ''), 10)
        this.formulario.bonificacion_cargo_municipal_pesos = isNaN(num) ? null : num
      }
    },
    bonificacionRetiroPesosCeseFuncionesFormateada: {
      get() {
        if (this.formulario.bonificacion_retiro_cese_fun_pesos == null || this.formulario.bonificacion_retiro_cese_fun_pesos === '') return ''
        return this.formulario.bonificacion_retiro_cese_fun_pesos
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      },
      set(val) {
        // Elimina puntos y otros caracteres no numéricos
        const num = parseInt(val.replace(/\./g, '').replace(/[^0-9]/g, ''), 10)
        this.formulario.bonificacion_retiro_cese_fun_pesos = isNaN(num) ? null : num
      }
    },
    bonificacionComplementariaPesosCeseFuncionesFormateada: {
      get() {
        if (this.formulario.bonificacion_complementaria_cese_fun_pesos == null || this.formulario.bonificacion_complementaria_cese_fun_pesos === '') return ''
        return this.formulario.bonificacion_complementaria_cese_fun_pesos
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      },
      set(val) {
        // Elimina puntos y otros caracteres no numéricos
        const num = parseInt(val.replace(/\./g, '').replace(/[^0-9]/g, ''), 10)
        this.formulario.bonificacion_complementaria_cese_fun_pesos = isNaN(num) ? null : num
      }
    },
    bonificacionMunicipalPesosCeseFuncionesFormateada: {
      get() {
        if (this.formulario.bonificacion_cargo_municipal_cese_fun_pesos == null || this.formulario.bonificacion_cargo_municipal_cese_fun_pesos === '') return ''
        return this.formulario.bonificacion_cargo_municipal_cese_fun_pesos
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      },
      set(val) {
        // Elimina puntos y otros caracteres no numéricos
        const num = parseInt(val.replace(/\./g, '').replace(/[^0-9]/g, ''), 10)
        this.formulario.bonificacion_cargo_municipal_cese_fun_pesos = isNaN(num) ? null : num
      }
    },
    mostrarCampoParaDejacion() {
      return (['dejacion', 'desiste'].includes(this.transicionSeleccionada) && this.postulacion.estado === 'beneficiario') || (['dejacion', 'desiste'].includes(this.postulacion.estado) && this.transicionSeleccionada === null)
    },
    formularioEditable() {
      const estadosEditables = ['beneficiario', 'dejacion', 'cese_funciones', 'fallecimiento']
      if (!estadosEditables.includes(this.postulacion.estado)) return false
      if (this.esSubdere) return this.edicionHabilitadaSubdere
      return true
    },
    mostrarSeccionDesiste() {
      return ['desiste', 'desiste_confirmado'].includes(this.postulacion.estado)
    },
    mostrarSeccionDejacion() {
      return (['dejacion', 'cese_confirmado', 'fallecimiento', 'fallecimiento_confirmado', 'pagado'].includes(this.postulacion.estado) && this.transicionSeleccionada === null) || ['dejacion'].includes(this.transicionSeleccionada)
    },
    mostrarSeccionCese() {
      return (['cese_funciones', 'cese_confirmado', 'fallecimiento', 'fallecimiento_confirmado', 'pagado'].includes(this.postulacion.estado) && this.transicionSeleccionada === null) || ['cese_funciones'].includes(this.transicionSeleccionada)
    },
    mostrarSeccionOtros() {
      return this.postulacion.estado === 'otros' && this.transicionSeleccionada === null
    },
    esSolicitudPendiente() {
      return ['desiste_solicita_dejacion', 'dejacion_solicita_desiste', 'cese_confirmado_solicita_retorno'].includes(this.postulacion.estado)
    },
    ultimaEntradaBitacora() {
      const bitacora = this.bitacora
      return bitacora.length > 0 ? bitacora[bitacora.length - 1] : null
    },
    estadosSolicitud() {
      return ['desiste_solicita_dejacion', 'dejacion_solicita_desiste', 'cese_confirmado_solicita_retorno']
    },
    opcionesCausaCese() {
      if (this.postulacion.sector === 'cementerio') {
        return [
          { text: 'Renuncia Voluntaria', value: 'renuncia_voluntaria' },
          { text: 'Artículo 161', value: 'articulo_161' },
          { text: 'Fallecimiento', value: 'fallecimiento' },
        ]
      }

      return [
        { text: 'Renuncia Voluntaria', value: 'renuncia_voluntaria' },
        { text: 'Pensión de Invalidez', value: 'pension_invalidez' },
        { text: 'Fallecimiento', value: 'fallecimiento' },
      ]
    },
    totalAntiguedadCalculado() {
      const ceseAnios = Number(this.formulario.antiguedad_cese?.anios) || 0
      const ceseMeses = Number(this.formulario.antiguedad_cese?.meses) || 0
      const ceseDias = Number(this.formulario.antiguedad_cese?.dias) || 0

      const otrosMunicipiosAnios = Number(this.formulario.antiguedad_otros_municipios?.anios) || 0
      const otrosMunicipiosMeses = Number(this.formulario.antiguedad_otros_municipios?.meses) || 0
      const otrosMunicipiosDias = Number(this.formulario.antiguedad_otros_municipios?.dias) || 0

      let anios = ceseAnios + otrosMunicipiosAnios
      let meses = ceseMeses + otrosMunicipiosMeses
      let dias = ceseDias + otrosMunicipiosDias

      if (dias >= 30) {
        meses += Math.floor(dias / 30)
        dias = dias % 30
      }
      if (meses >= 12) {
        anios += Math.floor(meses / 12)
        meses = meses % 12
      }

      return anios
    },
    esSubdere() {
      return this.$auth.can(['gestor-subdere-incentivo-retiro'])
    },
    tiposProceso() {
      return ['art-88']
    },
    transicionesDisponiblesSelect() {
      const etiquetasResolucion = {
        desiste_solicita_dejacion:        { dejacion: '(Confirmar)', desiste: '(Rechazar)' },
        dejacion_solicita_desiste:        { desiste: '(Confirmar)', dejacion: '(Rechazar)' },
        cese_confirmado_solicita_retorno: { cese_funciones: '(Confirmar)', cese_confirmado: '(Rechazar)' },
      }
      const etiquetas = etiquetasResolucion[this.postulacion.estado] ?? {}
      return this.transicionesDisponibles.map((t) => ({
        text: etiquetas[t]
          ? `${this.getEstadoTexto(t)} ${etiquetas[t]}`
          : this.getEstadoTexto(t),
        value: t,
      }))
    },
    documentosEtapa1() {
      const docs = []
      if (this.postulacion.archivo_prepostulacion_url) {
        docs.push({ tipo: 'prepostulacion', nombre: 'Formulario de Prepostulación' })
      }
      if (this.postulacion.archivo_postulacion_firmada_url) {
        docs.push({ tipo: 'documento_firmado', nombre: 'Postulación Firmada' })
      }
      if (this.postulacion.archivo_trabajo_pesado_url) {
        docs.push({ tipo: 'trabajo-pesado', nombre: 'Certificado Trabajo Pesado' })
      }
      if (this.postulacion.archivo_invalidez_url) {
        docs.push({ tipo: 'invalidez', nombre: 'Certificado de Invalidez' })
      }
      if (this.postulacion.certificado?.certificado_cumplimiento_firmado_url) {
        docs.push({ tipo: 'certificado_cumplimiento', nombre: 'Certificado de Cumplimiento Firmado' })
      }
      if (this.postulacion.certificado?.decreto_alcaldicio_url) {
        docs.push({ tipo: 'decreto', nombre: 'Decreto Alcaldicio' })
      }
      const historial = this.postulacion.historial_laboral || []
      historial.forEach((item, index) => {
        if (item.certificado_archivo_url) {
          docs.push({
            tipo: `certificado_antiguedad_${index}`,
            nombre: `Certificado de Antigüedad — ${item.institucion || `Registro ${index + 1}`}`,
          })
        }
      })
      return docs
    },
    documentosAgrupados() {
      const grupos = {}
      this.documentos.forEach((doc, index) => {
        const key = doc.transicion || 'sin_transicion'
        if (!grupos[key]) grupos[key] = []
        grupos[key].push({ ...doc, _index: index })
      })
      return grupos
    },
    observacionesSinResponder() {
      return this.observaciones.filter((o) => !o.respuesta).length
    },
    puedeGuardarFormulario() {
      const camposFaltantes = []
      const obligatoriosFaltantes = []

      if (((this.postulacion.estado === 'dejacion' && this.transicionSeleccionada === null) || this.transicionSeleccionada === 'dejacion') && this.formulario.solicita_anticipo_fcm) {
        const docsAnticipoFcmFaltantes = this.documentosAnticipoFcm.filter(
          (doc) => doc.obligatorio && !doc.subido && !this.archivosAnticipoFcm[doc.tipo]
        )
        obligatoriosFaltantes.push(...docsAnticipoFcmFaltantes)
      }

      if ((['dejacion', 'desiste'].includes(this.postulacion.estado) && this.transicionSeleccionada === null) || ['dejacion', 'desiste'].includes(this.transicionSeleccionada)) {
        this.formulario.numero_oficio_alcaldicio || camposFaltantes.push('Número de oficio alcaldicio')
        this.formulario.fecha_oficio_alcaldicio || camposFaltantes.push('Fecha de oficio alcaldicio')
      }

      if ((this.postulacion.estado === 'dejacion' && this.transicionSeleccionada === null) || this.transicionSeleccionada === 'dejacion') {
        this.formulario.fecha_cese_funciones || camposFaltantes.push('Fecha de cese de funciones')
      }
      if (((this.postulacion.estado === 'dejacion' && this.transicionSeleccionada === null) || this.transicionSeleccionada === 'dejacion') && this.postulacion.sector !== 'cementerio' && this.formulario.solicita_anticipo_fcm) {
        this.formulario.bonificacion_retiro_pesos || camposFaltantes.push('Bonificación retiro voluntario')
        this.formulario.bonificacion_complementaria_pesos || camposFaltantes.push('Bonificación complementaria')
        this.formulario.bonificacion_cargo_municipal_pesos || camposFaltantes.push('Bonificación cargo municipal')
      }

      this.condicionesCeseFunciones(camposFaltantes)

      return obligatoriosFaltantes.length === 0 && camposFaltantes.length === 0
    },
    puedeConfirmarTransicion() {
      if (!this.transicionSeleccionada) return false
      // Verificar que todos los documentos obligatorios estén subidos o se hayan seleccionado archivos
      const camposFaltantes = []
      const obligatoriosFaltantes = this.documentosRequeridos.filter(
        (doc) => doc.obligatorio && !doc.subido && !this.archivosTransicion[doc.tipo]
      )
      if (this.transicionSeleccionada === 'dejacion' && this.formulario.solicita_anticipo_fcm) {
        const docsAnticipoFcmFaltantes = this.documentosAnticipoFcm.filter(
          (doc) => doc.obligatorio && !doc.subido && !this.archivosAnticipoFcm[doc.tipo]
        )
        obligatoriosFaltantes.push(...docsAnticipoFcmFaltantes)
      }

      if (['dejacion', 'desiste'].includes(this.transicionSeleccionada)) {
        this.formulario.numero_oficio_alcaldicio || camposFaltantes.push('Número de oficio alcaldicio')
        this.formulario.fecha_oficio_alcaldicio || camposFaltantes.push('Fecha de oficio alcaldicio')
      }

      if (this.transicionSeleccionada === 'dejacion') {
        this.formulario.fecha_cese_funciones || camposFaltantes.push('Fecha de cese de funciones')
      }
      if (this.transicionSeleccionada === 'dejacion' && this.postulacion.sector !== 'cementerio' && this.formulario.solicita_anticipo_fcm) {
        this.formulario.bonificacion_retiro_pesos || camposFaltantes.push('Bonificación retiro voluntario')
        this.formulario.bonificacion_complementaria_pesos || camposFaltantes.push('Bonificación complementaria')
        this.formulario.bonificacion_cargo_municipal_pesos || camposFaltantes.push('Bonificación cargo municipal')
      }

      this.condicionesCeseFunciones(camposFaltantes)
      this.condicionesPagado(camposFaltantes)

      if (this.transicionSeleccionada === 'otros') {
        this.formularioOtros.detalle_otros || camposFaltantes.push('Detalle de incumplimiento de requisitos')
      }

      if (this.estadosSolicitud.includes(this.transicionSeleccionada)) {
        this.formularioSolicitudRetorno.motivo_solicitud_retorno || camposFaltantes.push('Motivo de la solicitud')
      }

      if (this.transicionSeleccionada === 'lista_espera') {
        this.formularioListaEspera.tipo_proceso || camposFaltantes.push('Tipo de proceso')
      }

      if (this.transicionSeleccionada === 'beneficiario') {
        this.formularioBeneficiario.resolucion_lista_espera_numero || camposFaltantes.push('Número de resolución Lista de Espera')
        this.formularioBeneficiario.resolucion_lista_espera_fecha || camposFaltantes.push('Fecha de resolución Lista de Espera')
        this.formularioBeneficiario.resolucion_beneficiario_numero || camposFaltantes.push('Número de resolución Beneficiario')
        this.formularioBeneficiario.resolucion_beneficiario_fecha || camposFaltantes.push('Fecha de resolución Beneficiario')
        this.formularioBeneficiario.fecha_publicacion_diario_oficial || camposFaltantes.push('Fecha de publicación Diario Oficial')
      }

      return obligatoriosFaltantes.length === 0 && camposFaltantes.length === 0
    },
  },
  mounted() {
    this.cargarDetalle()
  },
  methods: {
    async cargarDetalle() {
      this.cargando = true
      try {
        const { data } = await apiClient.get(
          `/tramites/incentivos-retiro/asignacion/beneficiarios/${this.$route.params.id}`
        )
        this.postulacion = data.postulacion
        this.transicionesDisponibles = data.transiciones_disponibles || []
        this.documentos = data.postulacion.documentos || []
        this.observaciones = data.postulacion.observaciones || []
        this.bitacora = data.postulacion.bitacora || []
        this.cumpleRequisitos = data.postulacion.cumple_requisitos
        if (data.postulacion.formulario_asignacion) {
          if (data.postulacion.formulario_asignacion.solicita_anticipo_fcm === null || data.postulacion.formulario_asignacion.solicita_anticipo_fcm === undefined) {
            data.postulacion.formulario_asignacion.solicita_anticipo_fcm = false
          }
          if (data.postulacion.formulario_asignacion.bonificacion_retiro_pesos === null || data.postulacion.formulario_asignacion.bonificacion_retiro_pesos === undefined) {
            data.postulacion.formulario_asignacion.bonificacion_retiro_pesos = data.postulacion.sector === 'cementerio' ? 0 : +data.postulacion.monto_retiro_voluntario || 0
          }
          if (data.postulacion.formulario_asignacion.bonificacion_complementaria_pesos === null || data.postulacion.formulario_asignacion.bonificacion_complementaria_pesos === undefined) {
            data.postulacion.formulario_asignacion.bonificacion_complementaria_pesos = data.postulacion.sector === 'cementerio' ? 0 : +data.postulacion.monto_retiro_complementario || 0
          }
          if (data.postulacion.formulario_asignacion.bonificacion_cargo_municipal_pesos === null || data.postulacion.formulario_asignacion.bonificacion_cargo_municipal_pesos === undefined) {
            data.postulacion.formulario_asignacion.bonificacion_cargo_municipal_pesos = data.postulacion.sector === 'cementerio' ? 0 : data.postulacion.formulario_asignacion.bonificacion_retiro_pesos + data.postulacion.formulario_asignacion.bonificacion_complementaria_pesos
          }
          if (data.postulacion.formulario_asignacion.bonificacion_retiro_cese_fun_pesos === null || data.postulacion.formulario_asignacion.bonificacion_retiro_cese_fun_pesos === undefined) {
            data.postulacion.formulario_asignacion.bonificacion_retiro_cese_fun_pesos =  0
          }
          if (data.postulacion.formulario_asignacion.bonificacion_complementaria_cese_fun_pesos === null || data.postulacion.formulario_asignacion.bonificacion_complementaria_cese_fun_pesos === undefined) {
            data.postulacion.formulario_asignacion.bonificacion_complementaria_cese_fun_pesos = 0
          }
          if (data.postulacion.formulario_asignacion.bonificacion_cargo_municipal_cese_fun_pesos === null || data.postulacion.formulario_asignacion.bonificacion_cargo_municipal_cese_fun_pesos === undefined) {
            data.postulacion.formulario_asignacion.bonificacion_cargo_municipal_cese_fun_pesos = data.postulacion.formulario_asignacion.bonificacion_retiro_cese_fun_pesos + data.postulacion.formulario_asignacion.bonificacion_complementaria_cese_fun_pesos
          }
          if (data.postulacion.formulario_asignacion.antiguedad_cese === null || data.postulacion.formulario_asignacion.antiguedad_cese === undefined) {
            data.postulacion.formulario_asignacion.antiguedad_cese = { anios: 0, meses: 0, dias: 0 }
          }
          if (data.postulacion.formulario_asignacion.antiguedad_otros_municipios === null || data.postulacion.formulario_asignacion.antiguedad_otros_municipios === undefined) {
            data.postulacion.formulario_asignacion.antiguedad_otros_municipios = { anios: 0, meses: 0, dias: 0 }
          }
          if (data.postulacion.formulario_asignacion.anios_antiguedad_postular === null || data.postulacion.formulario_asignacion.anios_antiguedad_postular === undefined) {
            data.postulacion.formulario_asignacion.anios_antiguedad_postular = data.postulacion.anios_antiguedad || data.postulacion.anios_servicio_bonificacion_adicional || 0
          }
          if (data.postulacion.formulario_asignacion.jornada_trabajo === null || data.postulacion.formulario_asignacion.jornada_trabajo === undefined) {
            data.postulacion.formulario_asignacion.jornada_trabajo = data.postulacion.jornada_trabajo || 0
          }
          if (data.postulacion.formulario_asignacion.bonificacion_adicional_uf === null || data.postulacion.formulario_asignacion.bonificacion_adicional_uf === undefined) {
            data.postulacion.formulario_asignacion.bonificacion_adicional_uf = 0
          }
          if (data.postulacion.formulario_asignacion.bono_antiguedad_uf === null || data.postulacion.formulario_asignacion.bono_antiguedad_uf === undefined) {
            data.postulacion.formulario_asignacion.bono_antiguedad_uf = 0
          }
          if (data.postulacion.formulario_asignacion.anios_trabajo_pesado === null || data.postulacion.formulario_asignacion.anios_trabajo_pesado === undefined) {
            data.postulacion.formulario_asignacion.anios_trabajo_pesado = 0
          }
          if (data.postulacion.formulario_asignacion.solicita_bono_trabajo_pesado === null || data.postulacion.formulario_asignacion.solicita_bono_trabajo_pesado === undefined) {
            data.postulacion.formulario_asignacion.solicita_bono_trabajo_pesado = false
          }
        }

        const documentosPostulacion = Array.isArray(data.postulacion.documentos) ? data.postulacion.documentos : []

        const posesionEfectivaDocs = documentosPostulacion.filter(doc => doc.tipo === 'posesion_efectiva')
        if (posesionEfectivaDocs.length > 0) {
          data.postulacion.formulario_asignacion.archivo_posesion_efectiva_url = posesionEfectivaDocs[posesionEfectivaDocs.length - 1].path || null
        }
        // archivo_trabajo_pesado_afp_url
        const trabajoPesadoAfpDocs = documentosPostulacion.filter(doc => doc.tipo === 'certificado_trabajo_pesado_afp')
        if (trabajoPesadoAfpDocs.length > 0) {
          data.postulacion.formulario_asignacion.archivo_trabajo_pesado_afp_url = trabajoPesadoAfpDocs[trabajoPesadoAfpDocs.length - 1].path || null
        }

        this.formulario = { ...(data.postulacion.formulario_asignacion || {}) }
        // Cargar documentos anticipo FCM si aplica
        if (this.formulario.solicita_anticipo_fcm) {
          this.cargarDocumentosAnticipoFcm()
        }
        if (typeof this.formulario.antiguedad_cese === 'string') {
          try {
            this.formulario.antiguedad_cese = JSON.parse(this.formulario.antiguedad_cese)
          } catch (error) {
            console.error('Error al parsear antigüedad al cese, se inicializa en 0:', error)
            this.formulario.antiguedad_cese = { anios: 0, meses: 0, dias: 0 }
          }
        }
        if (typeof this.formulario.antiguedad_otros_municipios === 'string') {
          try {
            this.formulario.antiguedad_otros_municipios = JSON.parse(this.formulario.antiguedad_otros_municipios)
          } catch (error) {
            console.error('Error al parsear antigüedad en otros municipios, se inicializa en 0:', error)
            this.formulario.antiguedad_otros_municipios = { anios: 0, meses: 0, dias: 0 }
          }
        }
      } catch (error) {
        notificarErrorResponse(error, 'Error al cargar detalle del beneficiario')
        console.error(error)
      } finally {
        this.cargando = false
      }
    },
    condicionesPagado(camposFaltantes) {
      if (this.transicionSeleccionada !== 'pagado') return
      this.formularioPagado.resolucion_pago_numero || camposFaltantes.push('N° resolución de pago')
      this.formularioPagado.resolucion_pago_fecha || camposFaltantes.push('Fecha resolución de pago')
      this.formularioPagado.fecha_pago || camposFaltantes.push('Fecha de pago por TGR')
    },
    condicionesCeseFunciones(camposFaltantes) {
      if ((this.postulacion.estado === 'cese_funciones' && this.transicionSeleccionada === null) || this.transicionSeleccionada === 'cese_funciones') {
        this.formulario.causa_cese || camposFaltantes.push('Causa de cese')
        if (this.formulario.causa_cese === 'fallecimiento') {
          this.formulario.archivo_posesion_efectiva_url || this.archivoPosesionEfectiva || camposFaltantes.push('Certificado de Posesión Efectiva')
        }
        this.formulario.fecha_cese_funciones || camposFaltantes.push('Fecha de cese de funciones')

        if (this.formulario.jornada_trabajo == null) {
          camposFaltantes.push('Jornada de trabajo')
        }
        if (this.formulario.posee_antiguedad_otros_municipios && (this.formulario.antiguedad_otros_municipios.anios === 0 && this.formulario.antiguedad_otros_municipios.meses === 0 && this.formulario.antiguedad_otros_municipios.dias === 0)) {
          camposFaltantes.push('Antigüedad en otros municipios')
        }

        this.formulario.bonificacion_retiro_cese_fun_pesos !== null && this.formulario.bonificacion_retiro_cese_fun_pesos !== undefined || camposFaltantes.push('Bonificación retiro voluntario')
        this.formulario.bonificacion_complementaria_cese_fun_pesos !== null && this.formulario.bonificacion_complementaria_cese_fun_pesos !== undefined || camposFaltantes.push('Bonificación complementaria')

        if (this.formulario.solicita_bono_trabajo_pesado) {
          this.formulario.anios_trabajo_pesado || camposFaltantes.push('Años de trabajo pesado')
          // this.formulario.archivo_trabajo_pesado_afp_url || this.archivoTrabajoPesadoAfp || camposFaltantes.push('Certificado de trabajo pesado AFP')
        }
        this.formulario.numero_decreto_cese || camposFaltantes.push('Número de decreto de cese')
        this.formulario.fecha_decreto_cese || camposFaltantes.push('Fecha de decreto de cese')
      }
    },
    calcularBonoCargoMunicipal() {
      this.formulario.bonificacion_cargo_municipal_pesos = (this.formulario.bonificacion_retiro_pesos || 0) + (this.formulario.bonificacion_complementaria_pesos || 0)
    },
    calcularBonoCeseFunciones() {
      this.formulario.bonificacion_cargo_municipal_cese_fun_pesos = (this.formulario.bonificacion_retiro_cese_fun_pesos || 0) + (this.formulario.bonificacion_complementaria_cese_fun_pesos || 0)
    },
    async habilitarGuardarFormulario () {
      try {
        await apiClient.post(
          `/tramites/incentivos-retiro/asignacion/beneficiarios/${this.$route.params.id}/activar-edicion-formulario`,
          { }
        )
        this.cargarDetalle()
      } catch (error) {
        console.error('Error al habilitar la edición del formulario:', error)
        notificarErrorResponse(error, 'Error al habilitar la edición del formulario')
      }
    },
    async habilitarSolicitarFcm() {
      try {
        await apiClient.post(
          `/tramites/incentivos-retiro/asignacion/habilitar-solicitar-fcm`,
          {
            municipalidad_id: this.postulacion.certificado?.municipalidad_id,
            postulacion_id: this.postulacion.id,
          }
        )
        notificar({ message: 'Solicitud FCM habilitada', severity: 'success' })
        await this.cargarDetalle()
      } catch (error) {
        notificarErrorResponse(error, 'Error al habilitar solicitar FCM')
      }
    },
    async deshabilitarSolicitarFcm() {
      try {
        await apiClient.post(
          `/tramites/incentivos-retiro/asignacion/deshabilitar-solicitar-fcm`,
          {
            municipalidad_id: this.postulacion.certificado?.municipalidad_id,
            postulacion_id: this.postulacion.id,
          }
        )
        notificar({ message: 'Solicitud FCM deshabilitada', severity: 'success' })
        await this.cargarDetalle()
      } catch (error) {
        notificarErrorResponse(error, 'Error al deshabilitar solicitar FCM')
      }
    },
    async habilitarSolicitarFcmMunicipalidad() {
      try {
        await apiClient.post(
          `/tramites/incentivos-retiro/asignacion/habilitar-solicitar-fcm`,
          { municipalidad_id: this.postulacion.certificado?.municipalidad_id }
        )
        notificar({ message: 'Solicitud FCM habilitada para toda la municipalidad', severity: 'success' })
        await this.cargarDetalle()
      } catch (error) {
        notificarErrorResponse(error, 'Error al habilitar solicitar FCM para la municipalidad')
      }
    },
    async deshabilitarSolicitarFcmMunicipalidad() {
      try {
        await apiClient.post(
          `/tramites/incentivos-retiro/asignacion/deshabilitar-solicitar-fcm`,
          { municipalidad_id: this.postulacion.certificado?.municipalidad_id }
        )
        notificar({ message: 'Solicitud FCM deshabilitada para toda la municipalidad', severity: 'success' })
        await this.cargarDetalle()
      } catch (error) {
        notificarErrorResponse(error, 'Error al deshabilitar solicitar FCM para la municipalidad')
      }
    },
    async guardarCumpleRequisitos() {
      if (this.cumpleRequisitos === null) {
        notificar({ message: 'Debe seleccionar una opción', severity: 'error' })
        return
      }
      this.guardandoCumple = true
      try {
        await apiClient.put(
          `/tramites/incentivos-retiro/asignacion/beneficiarios/${this.$route.params.id}/cumple-requisitos`,
          { cumple_requisitos: this.cumpleRequisitos }
        )
        notificar({ message: 'Evaluación guardada correctamente', severity: 'success' })
        await this.cargarDetalle()
      } catch (error) {
        notificarErrorResponse(error, 'Error al guardar evaluación')
      } finally {
        this.guardandoCumple = false
      }
    },
    async guardarFormularioAsignacion() {
      this.guardandoFormulario = true
      try {
        // Subir Certificado Trabajo Pesado AFP si hay archivo seleccionado
        // if (this.archivoTrabajoPesadoAfp) {
        //   const formData = new FormData()
        //   formData.append('tipo', 'certificado_trabajo_pesado_afp')
        //   formData.append('transicion', 'formulario_asignacion')
        //   formData.append('archivo', this.archivoTrabajoPesadoAfp)
        //   const { data: docData } = await apiClient.post(
        //     `/tramites/incentivos-retiro/asignacion/beneficiarios/${this.$route.params.id}/documentos`,
        //     formData,
        //     { headers: { 'Content-Type': 'multipart/form-data' } }
        //   )
        //   this.formulario.archivo_trabajo_pesado_afp_url = docData.documento?.path || true
        //   this.archivoTrabajoPesadoAfp = null
        // }

        // Subir Posesion Efectiva si hay archivo seleccionado
        if (this.archivoPosesionEfectiva) {
          const formData = new FormData()
          formData.append('tipo', 'posesion_efectiva')
          formData.append('transicion', 'formulario_asignacion')
          formData.append('archivo', this.archivoPosesionEfectiva)
          const { data: docData } = await apiClient.post(
            `/tramites/incentivos-retiro/asignacion/beneficiarios/${this.$route.params.id}/documentos`,
            formData,
            { headers: { 'Content-Type': 'multipart/form-data' } }
          )
          this.formulario.archivo_posesion_efectiva_url = docData.documento?.path || true
          this.archivoPosesionEfectiva = null
        }

        this.formulario.total_cargo_fiscal = this.totalBonificacionCargoFiscalUf ? +this.totalBonificacionCargoFiscalUf : 0
        // Actualizar total_antiguedad calculado
        this.formulario.total_antiguedad = this.totalAntiguedadCalculado

        // Convertir objetos a strings JSON antes de enviar
        const formularioParaEnviar = { ...this.formulario }
        if (formularioParaEnviar.antiguedad_cese && typeof formularioParaEnviar.antiguedad_cese === 'object') {
          formularioParaEnviar.antiguedad_cese = JSON.stringify(formularioParaEnviar.antiguedad_cese)
        }
        if (formularioParaEnviar.antiguedad_otros_municipios && typeof formularioParaEnviar.antiguedad_otros_municipios === 'object') {
          formularioParaEnviar.antiguedad_otros_municipios = JSON.stringify(formularioParaEnviar.antiguedad_otros_municipios)
        }
        await apiClient.put(
          `/tramites/incentivos-retiro/asignacion/beneficiarios/${this.$route.params.id}/formulario-asignacion`,
          formularioParaEnviar
        )
        notificar({ message: 'Formulario guardado correctamente', severity: 'success' })
        await this.cargarDetalle()
      } catch (error) {
        notificarErrorResponse(error, 'Error al guardar formulario')
      } finally {
        this.guardandoFormulario = false
        this.edicionHabilitadaSubdere = false
      }
    },
    async cargarDocumentosAnticipoFcm() {
      try {
        const { data } = await apiClient.get(
          `/tramites/incentivos-retiro/asignacion/beneficiarios/${this.$route.params.id}/documentos-anticipo-fcm`
        )
        this.documentosAnticipoFcm = data.documentos_anticipo_fcm || []
      } catch (error) {
        console.error('Error al cargar documentos anticipo FCM', error)
      }
    },
    async subirDocumentoAnticipoFcm(tipo) {
      const archivo = this.archivosAnticipoFcm[tipo]
      if (!archivo) return
      try {
        const formData = new FormData()
        formData.append('tipo', tipo)
        formData.append('transicion', 'anticipo_fcm')
        formData.append('archivo', archivo)
        await apiClient.post(
          `/tramites/incentivos-retiro/asignacion/beneficiarios/${this.$route.params.id}/documentos`,
          formData,
          { headers: { 'Content-Type': 'multipart/form-data' } }
        )
        notificar({ message: 'Documento subido exitosamente', severity: 'success' })
        this.$set(this.archivosAnticipoFcm, tipo, null)
        await this.cargarDocumentosAnticipoFcm()
      } catch (error) {
        notificarErrorResponse(error, 'Error al subir documento')
      }
    },
    async cargarDocumentosRequeridos() {
      if (!this.transicionSeleccionada) {
        this.documentosRequeridos = []
        return
      }
      try {
        const { data } = await apiClient.get(
          `/tramites/incentivos-retiro/asignacion/beneficiarios/${this.$route.params.id}/documentos-requeridos`,
          { params: { estado_nuevo: this.transicionSeleccionada } }
        )
        this.documentosRequeridos = data.documentos_requeridos || []
        this.documentosRequeridos.forEach((doc) => {
          if (doc.tipo === 'certificado_antiguedad_otros' && this.formulario.posee_antiguedad_otros_municipios) {
            doc.obligatorio = true
          }
          if (doc.tipo === 'certificado_trabajo_pesado' && this.formulario.solicita_bono_trabajo_pesado) {
            doc.obligatorio = true
          }
        })
        this.archivosTransicion = {}
      } catch (error) {
        notificarErrorResponse(error, 'Error al cargar documentos requeridos')
      }
    },
    confirmarTransicion() {
      this.dialogConfirmar = true
    },
    async ejecutarTransicion() {
      this.procesandoTransicion = true
      try {
        if (['dejacion', 'desiste', 'cese_funciones'].includes(this.transicionSeleccionada) && !this.estadosSolicitud.includes(this.postulacion.estado)) {
          await this.guardarFormularioAsignacion()
        }
        // Primero subir los archivos pendientes
        const clave = `${this.postulacion.estado}_${this.transicionSeleccionada}`
        for (const [tipo, archivo] of Object.entries(this.archivosTransicion)) {
          if (archivo) {
            const formData = new FormData()
            formData.append('tipo', tipo)
            formData.append('transicion', clave)
            formData.append('archivo', archivo)
            await apiClient.post(
              `/tramites/incentivos-retiro/asignacion/beneficiarios/${this.$route.params.id}/documentos`,
              formData,
              { headers: { 'Content-Type': 'multipart/form-data' } }
            )
          }
        }

        // Luego ejecutar la transición
        const payload = { estado_nuevo: this.transicionSeleccionada }
        if (this.transicionSeleccionada === 'pagado') {
          Object.assign(payload, this.formularioPagado)
        }
        if (this.transicionSeleccionada === 'otros') {
          Object.assign(payload, this.formularioOtros)
        }
        if (this.transicionSeleccionada === 'lista_espera') {
          Object.assign(payload, this.formularioListaEspera)
        }
        if (this.transicionSeleccionada === 'beneficiario') {
          Object.assign(payload, this.formularioBeneficiario)
        }
        if (this.estadosSolicitud.includes(this.transicionSeleccionada)) {
          Object.assign(payload, this.formularioSolicitudRetorno)
        }
        if (this.esSolicitudPendiente) {
          Object.assign(payload, this.formularioResolucionRetorno)
        }
        await apiClient.post(
          `/tramites/incentivos-retiro/asignacion/beneficiarios/${this.$route.params.id}/transicion`,
          payload
        )

        notificar({ message: 'Estado actualizado exitosamente', severity: 'success' })
        this.dialogConfirmar = false
        this.transicionSeleccionada = null
        this.documentosRequeridos = []
        this.archivosTransicion = {}
        this.formularioPagado = { resolucion_pago_numero: '', resolucion_pago_fecha: null, fecha_pago: null }
        this.formularioOtros = { detalle_otros: '' }
        this.formularioListaEspera = { tipo_proceso: null }
        this.formularioBeneficiario = {
          resolucion_lista_espera_numero: '',
          resolucion_lista_espera_fecha: null,
          resolucion_beneficiario_numero: '',
          resolucion_beneficiario_fecha: null,
          fecha_publicacion_diario_oficial: null,
        }
        this.formularioSolicitudRetorno = { motivo_solicitud_retorno: '' }
        this.formularioResolucionRetorno = { observacion_resolucion_retorno: '' }
        await this.cargarDetalle()
      } catch (error) {
        notificarErrorResponse(error, 'Error al cambiar estado')
        console.error(error)
      } finally {
        this.procesandoTransicion = false
      }
    },
    async eliminarDocumento(index) {
      if (!confirm('¿Está seguro que desea eliminar este documento?')) return
      try {
        await apiClient.delete(
          `/tramites/incentivos-retiro/asignacion/beneficiarios/${this.$route.params.id}/documentos/${index}`
        )
        notificar({ message: 'Documento eliminado', severity: 'success' })
        await this.cargarDetalle()
      } catch (error) {
        notificarErrorResponse(error, 'Error al eliminar documento')
      }
    },
    async agregarObservacion() {
      this.enviandoObservacion = true
      try {
        const { data } = await apiClient.post(
          `/tramites/incentivos-retiro/asignacion/beneficiarios/${this.$route.params.id}/observaciones`,
          { texto: this.nuevaObservacion }
        )
        this.observaciones = data.observaciones || []
        this.nuevaObservacion = ''
        notificar({ message: 'Observación agregada', severity: 'success' })
      } catch (error) {
        notificarErrorResponse(error, 'Error al agregar observación')
      } finally {
        this.enviandoObservacion = false
      }
    },
    async responderObservacion(obsId) {
      this.respondiendo = obsId
      try {
        const { data } = await apiClient.put(
          `/tramites/incentivos-retiro/asignacion/beneficiarios/${this.$route.params.id}/observaciones/${obsId}/respuesta`,
          { respuesta: this.respuestas[obsId] }
        )
        this.observaciones = data.observaciones || []
        this.$delete(this.respuestas, obsId)
        notificar({ message: 'Respuesta registrada', severity: 'success' })
      } catch (error) {
        notificarErrorResponse(error, 'Error al responder observación')
      } finally {
        this.respondiendo = null
      }
    },
    getNombreCompleto(item) {
      return [item.nombres, item.apellido_paterno, item.apellido_materno].filter(Boolean).join(' ')
    },
    getEstadoColor(estado) {
      const colores = {
        enviada: 'deep-purple',
        observada: 'amber darken-2',
        validada: 'light-blue',
        lista_espera: 'orange',
        beneficiario: 'blue',
        dejacion: 'purple',
        desiste: 'red lighten-1',
        desiste_confirmado: 'red darken-2',
        cese_funciones: 'teal',
        cese_confirmado: 'teal darken-2',
        fallecimiento: 'brown',
        fallecimiento_confirmado: 'brown darken-2',
        pagado: 'green',
        otros: 'blue-grey darken-1',
        desiste_solicita_dejacion: 'amber darken-3',
        dejacion_solicita_desiste: 'amber darken-3',
        cese_confirmado_solicita_retorno: 'amber darken-3',
      }
      return colores[estado] || 'grey'
    },
    getEstadoTexto(estado) {
      const textos = {
        enviada: 'Enviada',
        observada: 'Observada',
        validada: 'Validada',
        lista_espera: 'Lista de Espera',
        beneficiario: 'Beneficiario',
        dejacion: 'Dejación',
        desiste: 'Desiste',
        desiste_confirmado: 'Desiste Confirmado',
        cese_funciones: 'Cese de Funciones',
        cese_confirmado: 'Cese Confirmado',
        fallecimiento: 'Fallecimiento',
        fallecimiento_confirmado: 'Fallecimiento Confirmado',
        pagado: 'Pagado',
        otros: 'Otros',
        desiste_solicita_dejacion: 'Solicitud: Desiste → Dejación',
        dejacion_solicita_desiste: 'Solicitud: Dejación → Desiste',
        cese_confirmado_solicita_retorno: 'Solicitud: Retorno a Cese de Funciones',
      }
      return textos[estado] || estado
    },
    getSectorColor(sector) {
      return sector === 'cementerio' ? 'deep-purple lighten-4' : 'blue lighten-4'
    },
    getSectorTexto(sector) {
      const textos = {
        municipal: 'Municipal',
        cementerio: 'Cementerio',
      }
      return textos[sector] || sector || '-'
    },
    formatearTransicion(transicion) {
      // Las claves de transición tienen formato "estadoOrigen_estadoDestino"
      // Intentar parsear conociendo los estados válidos
      const estadosConocidos = [
        'enviada', 'observada', 'validada', 'lista_espera', 'beneficiario', 'dejacion', 'desiste',
        'desiste_confirmado', 'cese_funciones', 'cese_confirmado',
        'fallecimiento', 'fallecimiento_confirmado', 'pagado', 'otros',
        'desiste_solicita_dejacion', 'dejacion_solicita_desiste', 'cese_confirmado_solicita_retorno',
      ]
      for (const estado of estadosConocidos) {
        if (transicion.startsWith(estado + '_')) {
          const resto = transicion.slice(estado.length + 1)
          if (estadosConocidos.includes(resto)) {
            return `${this.getEstadoTexto(estado)} → ${this.getEstadoTexto(resto)}`
          }
        }
      }
      return transicion
    },
    formatearFecha(fecha) {
      if (!fecha) return '-'
      try {
        return format(new Date(fecha), 'DD/MM/YYYY HH:mm')
      } catch {
        return fecha
      }
    },
    descargarArchivoPostulacion(tipoArchivo) {
      let url = `/tramites/incentivos-retiro/postulaciones/${this.postulacion.id}/archivo/${tipoArchivo}`
      if (['decreto', 'certificado_cumplimiento'].includes(tipoArchivo)) {
        url = `/tramites/incentivos-retiro/certificados/${this.postulacion.certificado_id}/archivo/${tipoArchivo}`
      }

      apiClient
        .get(url, { responseType: 'blob' })
        .then((res) => {
          const blob = new Blob([res.data], { type: res.headers['content-type'] })
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = tipoArchivo + '.pdf'
          link.click()
          notificar({ message: 'Descarga exitosa', severity: 'success' })
        })
        .catch(() => {
          notificar({ message: 'El archivo no se encuentra disponible', severity: 'error' })
        })
    },
    porcentajeJornadaCementerio(horasSemanales) {
      const jornada = +horasSemanales
      let porcentaje = 100

      let jornadaCompleta = 44
      if (jornadaCompleta === 44 && this.postulacion.sector === 'cementerio') {
        jornadaCompleta = 42
      }

      if (jornada >= jornadaCompleta) return 100

      const porcentajeBruto = (jornada * 100) / jornadaCompleta
      porcentaje = Math.round(porcentajeBruto.toFixed(1))

      if (porcentaje <= 0) return 0

      return porcentaje
    },
    podiaTenerBonoAdicional() {
      const anios = this.postulacion.anios_servicio_bonificacion_adicional || 0
      if (
        !anios
        || (anios < 10 && this.formulario.causa_cese !== 'pension_invalidez')
        || (anios < 30 && this.formulario.causa_cese === 'pension_invalidez')
      ) {
        return false
      }
      return true
    },
    montoUfBonoAdicional() {
      const anios = this.totalAntiguedadCalculado || 0

      if (
        !this.podiaTenerBonoAdicional()
        || !anios
        || (anios < 10 && (this.formulario.causa_cese === 'renuncia_voluntaria' || this.formulario.causa_cese === 'articulo_161'))
        || (anios < 30 && this.formulario.causa_cese === 'pension_invalidez')
      ) {
        this.formulario.bonificacion_adicional_uf = 0
        return
      }
      const elemento = this.tablaBonoAdicional.find(b => anios >= b.anio_min && anios <= b.anio_max)

      if (elemento === undefined) {
        this.formulario.bonificacion_adicional_uf = 0
        return
      }

      // Informaron que la regla aplicaba para ambos sectores
      if (this.postulacion.sector === 'cementerio' || this.postulacion.sector === 'municipal') {
        const porcentaje = this.porcentajeJornadaCementerio(this.formulario.jornada_trabajo)/100
        this.formulario.bonificacion_adicional_uf = Math.round(elemento.monto_uf * porcentaje)
        return
      }
      this.formulario.bonificacion_adicional_uf = elemento.monto_uf
    },
    montoUfBonoTrabajo() {
      if (!this.formulario.anios_trabajo_pesado || this.formulario.anios_trabajo_pesado < 1) {
        this.formulario.bono_trabajo_pesado_uf = 0
        return
      }
      const anios = this.formulario.anios_trabajo_pesado <= 10 ? this.formulario.anios_trabajo_pesado : 10
      const elemento = this.tablaBonoPesado.find(b => anios === b.anio)

      this.formulario.bono_trabajo_pesado_uf = elemento.monto_uf
    },
    montoUfBonoAntiguedad() {
      const aniosTrabajados = this.totalAntiguedadCalculado || 0

      if (!aniosTrabajados || aniosTrabajados < 35) {
        this.formulario.bono_antiguedad_uf = 0
        return
      }

      const anios = aniosTrabajados <= 46 ? aniosTrabajados : 46
      const elemento = this.tablaBonoAntiguedad.find(b => anios === b.anio)

      this.formulario.bono_antiguedad_uf = elemento.monto_uf
    },
  },
}
</script>
